<!--协同备课学科统计图-->
<template>
    <div class="my-charts">
        <div :id="id"></div>
    </div>
</template>


<script>
import * as echarts from "echarts";


export default {
    name: "teaWorkAgeSubjectEchart",
    props: {
        id:{
            type: String,
            default:"tea_work_age_subject_echart"
        },
        itemList:{
            type: Array,
            default:[]
        },
        oneCountList:{
            type: Array,
            default:[]
        },
        twoCountList:{
            type: Array,
            default:[]
        },
        threeCountList:{
            type: Array,
            default:[]
        },
        fourCountList:{
            type: Array,
            default:[]
        },
    },
    watch:{

    },
    data() {
        return {
            barChart: null, // 柱状图
            chartOption:{
                title: {
                    text: '',
                    left: 'center',
                    top: 10,
                },
                tooltip: {
                    trigger: 'item'
                },
                grid: {
                    left: '40px',
                    right: '10px',
                    top: '10px',
                    bottom: '25px'
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        show: true,
                        interval:0,
                        rotate:0,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 8,
                        }
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        show: true,
                        textStyle: {    //文字样式
                            color: "black",
                            fontSize: 12,
                        }
                    },
                },
                series: [
                    {
                        name: '教龄1-5年',
                        type: 'bar',
                        color: [
                            '#68bbc4',
                        ],
                        data: []
                    },
                    {
                        name: '教龄5-10年',
                        type: 'bar',
                        color: [
                            '#5087ec',
                        ],
                        data: []
                    },
                    {
                        name: '教龄10年以上',
                        type: 'bar',
                        color: [
                            '#ffbf6b',
                        ],
                        data: []
                    },
                    {
                        name: '教龄未知',
                        type: 'bar',
                        color: [
                            '#3ba272',
                        ],
                        data: []
                    }
                ]
            }
        };
    },
    computed: {},
    mounted() {
        this.init();
    },
    updated() {
        this.init();
    },
    methods: {
        init() {
            this.barChart = echarts.init(document.getElementById(this.id));
            // this.chartOption.xAxis.data = []
            this.chartOption.xAxis.data = this.itemList
            // this.chartOption.series[0].data = []
            this.chartOption.series[0].data = this.oneCountList;
            // this.chartOption.series[1].data = []
            this.chartOption.series[1].data = this.twoCountList;
            // this.chartOption.series[2].data = []
            this.chartOption.series[2].data = this.threeCountList;
            // this.chartOption.series[3].data = []
            this.chartOption.series[3].data = this.fourCountList;
            console.log("数据："+this.fourCountList)
            this.barChart.setOption(this.chartOption);
        }
    }
};
</script>


<style scoped lang="scss">
.my-charts {
    width: 100%;
    height: calc(50vh - 150px);
    flex-direction: column;
    div {
        width: 100%!important;
        height: calc(50vh - 150px);
    }
}
</style>